"use client"
import { useAnalytics, useStorage } from '@hooks'
import React, { useEffect } from 'react'
import { Comments } from 'react-facebook'

export default function StationClient({stationId}: {stationId: string}) {
    const { add } = useStorage("history")
    useAnalytics(stationId)

    useEffect(() => {
        add(stationId)
    }, [])
    
    return (
        <Comments orderBy='reverse_time' href={`${process.env.NEXT_PUBLIC_URL}station/${stationId}`} lazy width={'100%'} />
    )
}